import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const benefits = [<>
    Tu hijo leerá con fluidez y{' '}
    <span className="text-green-600 font-bold" data-id="element-1">se sentirá orgulloso</span>.
  </>, <>
    <span className="text-green-600 font-bold" data-id="element-2">Ganará confianza</span> al leer
    en público y disfrutará cada palabra.
  </>, <>
    La lectura se convertirá en un{' '}
    <span className="text-green-600 font-bold" data-id="element-3">momento positivo</span> y sin
    frustraciones.
  </>, <>
    Te sentirás <span className="text-green-600 font-bold" data-id="element-4">tranquila</span>{' '}
    sabiendo que tiene un sistema probado.
  </>];
export function BenefitsSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="pt-2 pb-8 px-4 bg-[#E8F5E9]" data-id="element-5">
      <div className="max-w-4xl mx-auto" data-id="element-6">
        <div ref={ref} className={`w-full ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-7">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 text-center" data-id="element-8">
            ¿Qué logrará tu hijo con este sistema?
          </h2>

          <div className="space-y-5 max-w-2xl mx-auto" data-id="element-9">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-10">
                <div className="shrink-0 mt-1" data-id="element-11">
                  <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-12" />
                </div>
                <p className="text-lg text-gray-700 font-medium" data-id="element-13">{benefit}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}